module.exports = __webpack_public_path__ + "fonts/Knockout.a07f30e5.woff2";